var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.309 13.007"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Arrow Down Icon",
    d: "M26.654.756l-13 11.25-13-11.25",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}

export default __webpack_public_path__ + "dcdff4c9409d9353b53245a0478e8b1d.svg";
export { SvgChevronDown as ReactComponent };